import React, { useState, useEffect } from "react";

import { Formik, Form } from "formik";

import dataSourcesApi from "apis/dataSource";
import ingestionDataApi from "apis/ingestionData";
import usersApi from "apis/users";
import { Button, Pane, Typography } from "clearsense-ui/components";
import { Input, Select, Textarea } from "clearsense-ui/components/formik";

import {
  INITIAL_VALUES,
  VALIDATION_SCHEMA,
} from "../constants/createDataSource";

const CreateDataSource = ({
  isCreateDataSourceOpen,
  setIsCreateDataSourceOpen,
  fetchDataSources,
  currentDataSourceId = "",
  isEdit = false,
}) => {
  const [stewards, setStewards] = useState([]);
  const [schemas, setSchemas] = useState([]);
  const [currentlyEdited, setCurrentlyEdited] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchStewards = async () => {
    try {
      const { data } = await usersApi.fetch(1, 1000, "");
      setStewards(
        data?.users?.map(user => ({ label: user.name, value: user.key }))
      );
      setIsLoading(false);
    } catch (error) {
      logger.log(error);
    }
  };

  const fetchSchemas = async () => {
    try {
      const { data } = await ingestionDataApi.fetchSchemas();
      setSchemas(
        data?.result?.map(schema => ({ label: schema, value: schema }))
      );
    } catch (error) {
      logger.log(error);
    }
  };

  const getEditedDataSource = async () => {
    try {
      setIsLoading(true);
      const { data } = await dataSourcesApi.get(currentDataSourceId);
      const formattedData = {
        name: data.name,
        description: data.description,
        db_name: { label: data.db_name, value: data.db_name },
        approver: {
          label: `${data?.approver?.name}`,
          value: data?.approver?.id,
        },
        drafter: {
          label: `${data?.drafter?.name}`,
          value: data?.drafter?.id,
        },
      };
      setCurrentlyEdited(formattedData);
    } catch (error) {
      logger.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = async values => {
    try {
      const payload = {
        name: values.name,
        db_name: values.db_name.value,
        approver_id: values.approver.value,
        drafter_id: values.drafter.value,
        description: values.description,
      };
      isEdit
        ? await dataSourcesApi.edit(currentDataSourceId, payload)
        : await dataSourcesApi.create(payload);
      await fetchDataSources();
      setIsCreateDataSourceOpen(false);
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    fetchStewards();
    fetchSchemas();
  }, []);

  useEffect(() => {
    isEdit && getEditedDataSource();
  }, [currentDataSourceId]);

  return (
    <Pane
      isOpen={isCreateDataSourceOpen}
      onClose={() => setIsCreateDataSourceOpen(false)}
      isLoading={isLoading}
    >
      <Pane.Header>
        <Typography type="bold" className="-mt-3">
          {!isEdit ? "Create New Data Source" : "Edit Data source"}
        </Typography>
      </Pane.Header>
      <Formik
        initialValues={isEdit ? currentlyEdited : INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <Form noValidate>
          <Pane.Body>
            <div className="w-full flex flex-col gap-2 py-2">
              <Input
                name="name"
                label="Data Source Name"
                placeholder="Enter Data Source Name"
                required
              />
              <Select
                name="db_name"
                label="Database Name"
                placeholder="Select Database Name"
                options={schemas}
                required
              />
              <Select
                name="drafter"
                label="Drafter"
                placeholder="Select Drafter"
                options={stewards}
                isLoading={isLoading}
                required
              />
              <Select
                name="approver"
                label="Approver"
                placeholder="Select Approver"
                options={stewards}
                isLoading={isLoading}
                required
              />
              <Textarea
                name="description"
                label="Description"
                placeholder="Enter the description for the data source"
              />
            </div>
          </Pane.Body>
          <Pane.Footer className="gap-4 items-center">
            <Button label="Save and Close" type="submit" />
            <Button
              label="Cancel"
              style="secondary"
              onClick={() => {
                setIsCreateDataSourceOpen(false);
              }}
            />
          </Pane.Footer>
        </Form>
      </Formik>
    </Pane>
  );
};

export default CreateDataSource;
